import Icon from './Icon';

function Browser({ hover, shadow, color1, color2, className, ...props }) {
  return (
    <Icon
      {...{ hover, shadow, color1, color2, className, ...props }}
      width="1200"
      height="850"
    >
      <path
        fillRule="evenodd"
        fill={color2 || 'rgb(75, 75, 75)'}
        d="M1179.000,795.000 L20.000,795.000 C8.954,795.000 -0.000,786.046 -0.000,775.000 L-0.000,20.000 C-0.000,8.954 8.954,-0.000 20.000,-0.000 L1179.000,-0.000 C1190.046,-0.000 1199.000,8.954 1199.000,20.000 L1199.000,775.000 C1199.000,786.046 1190.046,795.000 1179.000,795.000 Z"
      />
      <path
        fillRule="evenodd"
        fill={color1 || 'rgb(203, 203, 203)'}
        d="M1142.228,759.320 L55.658,759.320 C44.612,759.320 35.658,750.365 35.658,739.320 L35.658,176.101 C35.658,165.055 44.612,156.101 55.658,156.101 L1142.228,156.101 C1153.273,156.101 1162.228,165.055 1162.228,176.101 L1162.228,739.320 C1162.228,750.365 1153.273,759.320 1142.228,759.320 ZM1142.228,110.386 L1126.512,110.386 C1115.466,110.386 1106.512,101.431 1106.512,90.386 L1106.512,72.405 C1106.512,61.360 1115.466,52.405 1126.512,52.405 L1142.228,52.405 C1153.273,52.405 1162.228,61.360 1162.228,72.405 L1162.228,90.386 C1162.228,101.431 1153.273,110.386 1142.228,110.386 ZM1060.883,110.386 L1045.167,110.386 C1034.122,110.386 1025.167,101.431 1025.167,90.386 L1025.167,72.405 C1025.167,61.360 1034.122,52.405 1045.167,52.405 L1060.883,52.405 C1071.929,52.405 1080.883,61.360 1080.883,72.405 L1080.883,90.386 C1080.883,101.431 1071.929,110.386 1060.883,110.386 ZM979.538,110.386 L963.822,110.386 C952.777,110.386 943.822,101.431 943.822,90.386 L943.822,72.405 C943.822,61.360 952.777,52.405 963.822,52.405 L979.538,52.405 C990.584,52.405 999.538,61.360 999.538,72.405 L999.538,90.386 C999.538,101.431 990.584,110.386 979.538,110.386 ZM892.622,110.386 L55.658,110.386 C44.612,110.386 35.658,101.431 35.658,90.386 L35.658,72.405 C35.658,61.360 44.612,52.405 55.658,52.405 L892.622,52.405 C903.667,52.405 912.622,61.360 912.622,72.405 L912.622,90.386 C912.622,101.431 903.667,110.386 892.622,110.386 Z"
      />
      <text
        fill="#eeeeee"
        transform="matrix( 1.11431226765799, 0, 0, 1.11500701262272,308.794722583643, 524.497896213184)"
      >
        <tspan
          fontSize="211.667px"
          fontFamily="Open Sans"
          fill={color2 || 'rgb(75, 75, 75)'}
        >
          www
        </tspan>
      </text>
    </Icon>
  );
}

export default Browser;
